export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'alaskaair',
    name: 'Alaska Airlines',
  },
  {
    id: 'alliant',
    name: 'Alliant Credit Union',
  },
  {
    id: 'ally',
    name: 'Ally Bank',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'aspca',
    name: 'ASPCA',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'chase',
    name: 'Chase',
  },
  {
    id: 'citi',
    name: 'Citi',
  },
  {
    id: 'discover',
    name: 'Discover',
  },
  {
    id: 'fidelity',
    name: 'Fidelity Investments',
  },
  {
    id: 'geico',
    name: 'Geico',
  },
  {
    id: 'interactivebrokers',
    name: 'Interactive Brokers',
  },
  {
    id: 'lemonade',
    name: 'Lemonade',
  },
  {
    id: 'lendingclub',
    name: 'LendingClub',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'marriott',
    name: 'Marriott',
  },
  {
    id: 'navy',
    name: 'Navy Federal Credit Union',
  },
  {
    id: 'pennymac',
    name: 'Pennymac',
  },
  {
    id: 'pnc',
    name: 'PNC Bank',
  },
  {
    id: 'rate',
    name: 'Rate',
  },
  {
    id: 'rocket',
    name: 'Rocket Mortgage',
  },
  {
    id: 'sofi',
    name: 'SoFi',
  },
  {
    id: 'travelers',
    name: 'Travelers',
  },
  {
    id: 'ufb',
    name: 'UFB Portfolio Savings',
  },
  {
    id: 'united',
    name: 'United',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'viobank',
    name: 'Vio Bank',
  },
  {
    id: 'wealthfront',
    name: 'Wealthfront',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
  {
    id: 'wyndham',
    name: 'Wyndham Hotels and Resorts',
  },
];
